import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.id = this.getData('id')

        const isEnabled = getComputedStyle(this.el).getPropertyValue('--modal-team-trigger-enabled') === 'true'
        if(isEnabled) {
            this.events = {
                click: {
                    'toggler' : 'open'
                }
            }
        }
    }

    open(e) {
        e.preventDefault()
        this.call('open', this.id, 'ModalTeam')
    }
}
